export default __webpack_public_path__ + "static/media/washupWelcomePromotionBanner.a0f9ef78.png";